import consumer from "./consumer"
let current_user
consumer.subscriptions.create("CallsChannel", {
    connected() {
        // Called when the subscription is ready for use on the server
        current_user = $('#current_user_id').val();
    },

    disconnected() {
        // Called when the subscription has been terminated by the server
    },

    received(data) {
        console.log(data,"<<<<<<<,data>>")
        if (data.content.notification_type == "consent_create") {
            if (data.content.refer_to === parseInt(current_user)) {
                const contractId = data.content.contract_id;
                const $countElement = $('.client-consents-count').filter(function() { return $(this).hasClass(String(contractId)); });
                let currentCount = parseInt($countElement.first().text()) || 0;
                $countElement.text(currentCount + 1).show();

            }
        } else if (data.content.call && data.content.call.provider === parseInt(current_user)) {
            $("#noty").removeClass("d-block").addClass("d-none");
            $("#live-noty").removeClass("d-none").addClass("d-block");
            let countData = $('#nav-noti-count').text();
            if (countData === '' || countData === 'undefined') {
                countData = 0;
            }
            $('#nav-noti-count').text(parseInt(countData) + 1);
        }
    }
});